"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var helpers_1 = require("./helpers");
var G = __importStar(require("./globals"));
/** Create a frameloop singleton */
var FrameLoop = /** @class */function () {
  function FrameLoop(
  // The global `requestAnimationFrame` must be dereferenced to avoid "Illegal invocation" errors
  requestFrame) {
    var _this = this;
    if (requestFrame === void 0) {
      requestFrame = function requestFrame(fn) {
        return (void 0, G.requestAnimationFrame)(fn);
      };
    }
    this.idle = true;
    var writing = false;
    // The most recent framestamp
    var lastTime = 0;
    // The active animations for the current frame, sorted by lowest priority first
    var animations = [];
    // The priority of the currently advancing animation.
    // To protect against a race condition whenever a frame is being processed,
    // where the filtering of `animations` is corrupted with a shifting index,
    // causing animations to potentially advance 2x faster than intended.
    var priority = 0;
    // Animations starting on the next frame
    var startQueue = new Set();
    // Flushed after all animations are updated.
    // Used to dispatch events to an "onFrame" prop, for example.
    var frameQueue = new Set();
    // Flushed at the very end of each frame.
    // Used to avoid layout thrashing in @react-spring/web, for example.
    var writeQueue = new Set();
    // Add an animation to the frameloop
    var start = function start(animation) {
      var index = animations.findIndex(function (other) {
        return other.priority > animation.priority;
      });
      animations.splice(~index ? index : animations.length, 0, animation);
      kickoff();
    };
    // Start the frameloop
    var kickoff = function kickoff() {
      if (_this.idle) {
        _this.idle = false;
        lastTime = G.performanceNow();
        requestFrame(update);
      }
    };
    // Process the current frame
    var update = this.update = function (time) {
      if (_this.idle) return;
      if (helpers_1.is.und(time)) {
        time = G.performanceNow();
      }
      var dt = time - lastTime;
      if (dt > 0) {
        // http://gafferongames.com/game-physics/fix-your-timestep/
        if (dt > 64) dt = 64;
        if (startQueue.size) {
          startQueue.forEach(start);
          startQueue.clear();
        }
        G.batchedUpdates(function () {
          // Animations can be added while the frameloop is updating,
          // but they need a higher priority to be started on this frame.
          if (animations.length) {
            animations = animations.filter(function (animation) {
              priority = animation.priority;
              // Animations may go idle before the next frame.
              if (!animation.idle) {
                animation.advance(dt);
              }
              // Remove idle animations.
              return !animation.idle;
            });
            priority = 0;
          }
          if (frameQueue.size) {
            frameQueue.forEach(function (onFrame) {
              return onFrame(time);
            });
            frameQueue.clear();
          }
          if (writeQueue.size) {
            writing = true;
            writeQueue.forEach(function (write) {
              return write(time);
            });
            writeQueue.clear();
            writing = false;
          }
        });
        if (!animations.length) {
          _this.idle = true;
          return;
        }
      }
      lastTime = time;
      requestFrame(update);
    };
    this.start = function (animation) {
      var index = animations.indexOf(animation);
      if (~index) {
        animations.splice(index, 1);
      }
      if (priority > animation.priority) {
        startQueue.add(animation);
      } else {
        start(animation);
      }
    };
    this.onFrame = function (cb) {
      frameQueue.add(cb);
      kickoff();
    };
    this.onWrite = function (cb) {
      if (writing) cb(lastTime);else writeQueue.add(cb);
    };
  }
  return FrameLoop;
}();
exports.FrameLoop = FrameLoop;